// extracted by mini-css-extract-plugin
export var body = "Checkbox-module--body--6c969";
export var input = "Checkbox-module--input--95f7e";